import * as React from 'react'
import { memo } from 'react'
const SvgGift = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 27.43 12"
  >
    <path
      fill="#fff"
      d="M1.714 12A1.714 1.714 0 0 1 0 10.286v-6a1.714 1.714 0 0 1 1.714-1.715h5A3.81 3.81 0 0 1 10.448 0a3.94 3.94 0 0 1 3.429 1.858A3.94 3.94 0 0 1 17.305 0a3.81 3.81 0 0 1 3.736 2.571h4.674a1.714 1.714 0 0 1 1.715 1.714v6A1.714 1.714 0 0 1 25.716 12Zm24-.857a.86.86 0 0 0 .857-.857V7.715H14.305v3.428ZM.857 10.286a.86.86 0 0 0 .857.857h11.734V7.715H.857Zm25.716-3.429V4.285a.86.86 0 0 0-.857-.857H14.305v3.429Zm-13.125 0V3.429H1.714a.86.86 0 0 0-.857.857v2.571Zm6.687-4.286a3.01 3.01 0 0 0-2.83-1.714 3.01 3.01 0 0 0-2.829 1.714Zm-6.857 0a3.01 3.01 0 0 0-2.83-1.714 3.01 3.01 0 0 0-2.83 1.714Z"
      data-name="Unione 36"
    />
  </svg>
)
const Memo = memo(SvgGift)
export default Memo
